/* eslint-disable @typescript-eslint/no-explicit-any */
import { Agent } from '../types/agent';
import { getCurrentAgentId, privateFulcrumApi } from '../lib/fulcrumApi';
import { persistAuthTokens, removeAuthToken } from '../lib/accessTokens';
import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';
import { VIAUserPayload } from '../types/viaUserPayload';

/**
 * Hook to authorize the current user.
 * @warning In production mode authorization is handled by the backend gateway, we just fetch the user data.
 *          In development mode authorization is handled by the frontend (fetching auth token).
 *          * Specifics of the API implementation, if you need more details contact with Al or Garth *
 */
export const useQueryMe = (): UseQueryResult<VIAUserPayload | null> =>
  useQuery({
    queryKey: ['/auth/me'],
    // refetch current user data every 8h
    staleTime: 1000 * 60 * 60 * 8,
    retry: false,
    queryFn: async () => {
      // if (process.env.NODE_ENV === 'production') {
      // Fetch user info
      const { data } = await privateFulcrumApi.get<VIAUserPayload>('/VIASessionPayload');
      (window as any).currentAgentID = data.optionalParameters.agentID;
      (window as any).agentUserName = data.username;
      return data;
      // } else {
      //   // Do strange api auth only for local development
      //   const token = await privateFulcrumApi.get<string>('/ApiAuth').then(({ data }) => data);
      //   persistAuthTokens({ fulcrumToken: token });
      //   (window as any).currentAgentID = 1001; // Use this agent ID for local development
      //   (window as any).agentUserName = '38203';

      //   return null;
      // }
    },
  });

/**
 * Mutation to logout the current user (agent)
 */
export const useMutationLogout = (): UseMutationResult<void> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      removeAuthToken();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/auth/me'] });
    },
  });
};

/**
 * Fetch the current agent data
 */
export const useGetCurrentAgent = (): UseQueryResult<Agent> => {
  return useQuery<Agent>({
    queryKey: [`/Agent/${getCurrentAgentId()}`],
  });
};
